import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import { lock, unlock, clearBodyLocks } from 'tua-body-scroll-lock';

// import anime from 'animejs/lib/anime.es.js';
// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

Alpine.data('videoSection', () => ({

    isVideoModalOpen: false,
    clientName: '',
    videoTitle: '',
    freelanceDirectorName: '',
    directorName: '',
    directorURL: '',
    directorIndex: 0,
    shareURL: '',
    shareImage: '',

    closeVideoModal() {
        this.isVideoModalOpen = false;
        document.querySelector('.js-vid-container').innerHTML = '';

        const params = new URLSearchParams(window.location.search);
        if(params.get('video')){
            params.delete('video');
            let newUrl = window.location.origin + window.location.pathname + '?' + params.toString();
            window.history.pushState({path:newUrl},'',newUrl);
        }

        clearBodyLocks();
    },

    directorPrevVideo() {
        const allVids = document.querySelectorAll('.js-vid-list .video-tile button');
        const prevIndex = this.directorIndex - 2;

        if (prevIndex < 0) {
            allVids[allVids.length - 1].click();
        } else {
            allVids[prevIndex].click();
        }
    },

    directorNextVideo() {
        const allVids = document.querySelectorAll('.js-vid-list .video-tile button');
        const nextIndex = this.directorIndex;

        console.log(nextIndex);
        console.log(allVids);

        if(nextIndex > allVids.length) {
            allVids[0].click();
        } else {
            allVids[nextIndex].click();
        }
    },

    triggerModal(videoId, thumbnail) {
        if(videoId) {
            const vidPosterElement = `<img class="w-full h-full absolute inset-0 z-[3] pointer-events-none transition-opacity duration-700 ease-in-out" src="${thumbnail}">`;

            const vidElement = `<video class="absolute top-0 left-0 w-full h-full" preload loop controls playsinline poster="${thumbnail}">
                        <source type="video/mp4" src="${videoId}">
                    </video>`;
                
            const vidPlayIcon = `<span class="modal-play absolute z-[4] transition-opacity duration-700 ease-in-out hover:opacity-40 w-full h-full !opacity-100">
            <div class="flex items-center justify-center w-full h-full">
            <span class="flex flex-col items-center group-hover:scale-110 transition-transform ease-in-out justify-center border-[2px] border-beige w-[40px] lg:w-[60px] rounded-full h-[40px] lg:h-[60px]">
                    <svg class="translate-x-[2px] w-[18px] lg:w-[23px] fill-current" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M23 13L0.499999 25.9904L0.5 0.00961778L23 13Z"></path> </svg>
                    </span></span></div>`;

            document.querySelector('.js-vid-container').innerHTML =  vidElement + vidPosterElement + vidPlayIcon;

            window.setTimeout(() => {

                document.querySelector('.js-vid-container .modal-play').addEventListener('click', function() {

                    document.querySelector('.js-vid-container img').classList.add('!opacity-0');
                    document.querySelector('.js-vid-container img').classList.add('!pointer-events-none');
                    document.querySelector('.js-vid-container .modal-play').classList.add('!opacity-0');
                    document.querySelector('.js-vid-container .modal-play').classList.add('!pointer-events-none');
    
                    let modalVideo = document.querySelector('.js-vid-container').querySelector('video');
                    let promise = modalVideo.play();
                    if (promise !== undefined) {
                        promise.then(_ => {
                        }).catch(error => {
                    });
                    }
                }, {once: true})

            }, 250);

            bodyLock(document.querySelector('.js-vid-container'));

            // let modalVideo = document.querySelector('.js-vid-container').querySelector('video');
            // let promise = modalVideo.play();
            // if (promise !== undefined) {
            //     promise.then(_ => {
            //         document.querySelector('.js-vid-container .modal-play').classList.add('!opacity-0');
            //     }).catch(error => {
                
            // });
            // }

        }
    }
}));

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();

window.copy = copy;
window.bodyLock = lock;
window.bodyUnlock = unlock;
window.clearBodyLocks = clearBodyLocks;

